import { Button, cn, Link, withDialog, type WithDialogProps } from '@kidslabs/mario-nextjs-react-ui-core';
import styles from './authentication-faq.module.css';
import { Location } from '../../types/front.graphql';
import { type FC, useCallback } from 'react';
import { SupportMenu } from '../support-menu/support-menu';
import { type AuthenticationFaqprops } from './authentication-faq.types';
import { useTranslation } from 'next-i18next';
import { HOTLINE, ZALO_CHAT_LINK } from '@kidslabs/module-core';

const AuthenticationFaqContent: FC<AuthenticationFaqprops & WithDialogProps> = ({
    isMobile = true,
    setDialogOptions,
    showDialog,
    hideDialog,
}) => {
    const { t } = useTranslation('common');

    const handleShowDialog = useCallback(
        (message: string) => {
            setDialogOptions({
                title: t('text-notification'),
                content: message,
                acceptLabel: t('text_close'),
                onAccept: hideDialog,
            });
            showDialog();
        },
        [hideDialog, setDialogOptions, showDialog, t]
    );

    const callHotline = useCallback(() => {
        handleShowDialog(t('text_call_hotline', { hotline: HOTLINE }));
    }, [handleShowDialog, t]);

    return (
        <div className={styles.container}>
            <SupportMenu location={Location.Authentication} isMobile={isMobile} />
            <div className={styles.actions}>
                {isMobile ? (
                    <Link className={cn(styles.button, styles.hotline)} href="tel:0901234567">
                        {t('text_hotline')}
                    </Link>
                ) : (
                    <Button onClick={callHotline} className={cn(styles.button, styles.hotline)}>
                        {t('text_hotline')}
                    </Button>
                )}

                <Link className={cn(styles.button, styles.consultation)} href={ZALO_CHAT_LINK}>
                    {t('text_call_contact')}
                </Link>
            </div>
        </div>
    );
};

export const AuthenticationFaqInner = withDialog(AuthenticationFaqContent);

export const AuthenticationFaq = (props: AuthenticationFaqprops) => {
    return <AuthenticationFaqInner {...props} />;
};
